var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1162 0H6.44646C3.35165 0 0.834839 2.2425 0.834839 5V35C0.834839 37.7575 3.35165 40 6.44646 40H40.1162C43.211 40 45.7278 37.7575 45.7278 35V5C45.7278 2.2425 43.211 0 40.1162 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7133 20H31.6987V15C31.6987 13.62 32.9557 13.75 34.5045 13.75H37.3104V7.5H31.6987C27.0495 7.5 23.2813 10.8575 23.2813 15V20H17.6697V26.25H23.2813V40H31.6987V26.25H35.9074L38.7133 20Z",
    fill: "#4764AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.893,
    height: 40,
    fill: "white",
    transform: "translate(0.834839)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a5a660a48a6e2f979b48e440ab2ec891.svg";
export { ForwardRef as ReactComponent };